import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import '../InputCheckout/InputCheckout.scss';

const formatPhone = (digits) => {
  if (!digits) return '';
  if (digits.length <= 2) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 10)
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
};

const PhoneInputCheckout = ({
  label = '',
  id,
  className = '',
  name,
  value,
  onChange,
  errorMessage = '',
  isValid = false,
  onBlur,
  disabled,
  placeholder
}) => {
  const displayValue = useMemo(() => formatPhone(value), [value]);

  const handleInput = useCallback((e) => {
    const raw = e.target.value.replace(/\D/g, '').slice(0, 11);
    const syntheticEvent = {
      target: { name, value: raw },
    };
    onChange(syntheticEvent);
  }, [name, onChange]);

  return (
    <div className={`field ${className}`}>
      {label && <div className="title">{label}</div>}
      <input
        id={id}
        type="tel"
        disabled={disabled}
        className={`input ${errorMessage ? 'error' : ''} ${isValid ? 'valid' : ''}`}
        name={name}
        value={displayValue}
        placeholder={placeholder}
        onChange={handleInput}
        onBlur={onBlur}
      />
      {errorMessage && <div className="input-error-msg">{errorMessage}</div>}
    </div>
  );
};

PhoneInputCheckout.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  isValid: PropTypes.bool,
  errorMessage: PropTypes.string
};

export default PhoneInputCheckout;
